if (!customElements.get('infinite-loading')) {
  class InfiniteLoading extends HTMLElement {
    static GRID_SELECTOR = '#product-grid';
    static LOADING_CLASS = 'is-loading';
    static NEW_URL_SELECTOR = '[js-next-url]';
    static LOADER_SELECTOR = '[js-loading-indicator]';

    constructor() {
      super();

      this.handleUpdateInfiniteObserverRef =
        this.handleUpdateInfiniteObserver.bind(this);
    }

    observeScroll() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.loading) {
              this.loadNextPage();
            }
          });
        },
        { rootMargin: '200px' },
      );

      this.observer.observe(this.lastItem);
    }

    async loadNextPage() {
      if (!this.nextUrl) {
        console.log('No more pages to load.');
        this.observer.disconnect();
        return;
      }

      this.loading = true;
      this.classList.add(InfiniteLoading.LOADING_CLASS);

      try {
        const response = await fetch(this.nextUrl);
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newProducts = doc.querySelector(InfiniteLoading.GRID_SELECTOR);
        this.nextUrl = doc
          .querySelector(InfiniteLoading.NEW_URL_SELECTOR)
          ?.getAttribute('href');

        if (newProducts && newProducts.children.length > 0) {
          this.grid.append(...newProducts.children);

          this.lastItem = this.grid.querySelector(':scope > *:last-child');

          this.observer.observe(this.lastItem);
        } else {
          this.observer.disconnect();
        }
      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        this.loading = false;
        this.classList.remove(InfiniteLoading.LOADING_CLASS);
      }
    }

    handleUpdateInfiniteObserver() {
      this.getAllElements();

      this.observer.unobserve(this.lastItem);
      this.lastItem = this.grid.querySelector(':scope > *:last-child');
      this.observer.observe(this.lastItem);
    }

    disconnectedCallback() {
      document.removeEventListener(
        'update-infinite-observer',
        this.handleUpdateInfiniteObserverRef,
      );
    }

    getAllElements() {
      this.nextUrl = this.querySelector(
        InfiniteLoading.NEW_URL_SELECTOR,
      )?.getAttribute('href');
      if (!this.nextUrl) return;

      this.loader = this.querySelector(InfiniteLoading.LOADER_SELECTOR);
      if (!this.loader) return;

      this.grid = document.querySelector(InfiniteLoading.GRID_SELECTOR);
      if (!this.grid) return;

      this.lastItem = this.grid.querySelector(':scope > *:last-child');
    }

    connectedCallback() {
      this.loading = false;

      this.getAllElements();

      this.observeScroll();

      document.addEventListener(
        'update-infinite-observer',
        this.handleUpdateInfiniteObserverRef,
      );
    }
  }

  customElements.define('infinite-loading', InfiniteLoading);
}
